import type { SystemSettings } from '@yawi/types';
import { safeStorage } from './safeStorage';

const KEY = 'hommi_settings';

/**
 * Cache del navegador para pintar el branding antes de la red. No guarda la cuenta
 * bancaria ni los datos fiscales: dependen del usuario y de su sección activa, y
 * este cache lo comparte cualquiera que use el mismo navegador.
 */
export const writeSettingsCache = (settings: SystemSettings): void => {
  safeStorage.setItem(KEY, JSON.stringify({ ...settings, bankInfo: undefined, fiscalData: undefined }));
};

/** Sin `bankInfo`/`fiscalData` (también en caches viejos): llegan con el fetch. */
export const readSettingsCache = (): SystemSettings | null => {
  const cached = safeStorage.getItem(KEY);
  if (!cached) return null;
  try {
    const { bankInfo: _bankInfo, fiscalData: _fiscalData, ...rest } = JSON.parse(cached);
    return rest as SystemSettings;
  } catch {
    return null; // Corrupted cache
  }
};
